<template>
  <div>
    <div
      class="methods-back-button"
      :class="{ active: selectedPoint !== null }"
    >
      <a
        href=""
        class="lg-btn box-btn"
        v-on:click.prevent="selectedPoint = null"
      >
        <span class="front-face">
          <span class="back">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22.369"
              height="24.676"
              viewBox="0 0 22.369 24.676"
            >
              <g
                id="Group_13"
                data-name="Group 13"
                transform="translate(-249.631 -119.662)"
              >
                <line
                  id="Line_7"
                  data-name="Line 7"
                  x1="22"
                  transform="translate(250 132)"
                  fill="none"
                  stroke-width="1"
                ></line>
                <line
                  id="Line_8"
                  data-name="Line 8"
                  y1="12"
                  x2="11"
                  transform="translate(250 120)"
                  fill="none"
                  stroke-width="1"
                ></line>
                <line
                  id="Line_13"
                  data-name="Line 13"
                  x1="11"
                  y1="12"
                  transform="translate(250 132)"
                  fill="none"
                  stroke-width="1"
                ></line>
              </g>
            </svg>
          </span>
          <span class="label"> Back </span>
        </span>
        <span class="side-face">
          <span class="back">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22.369"
              height="24.676"
              viewBox="0 0 22.369 24.676"
            >
              <g
                id="Group_13"
                data-name="Group 13"
                transform="translate(-249.631 -119.662)"
                stroke="#888"
              >
                <line
                  id="Line_7"
                  data-name="Line 7"
                  x1="22"
                  transform="translate(250 132)"
                  fill="none"
                  stroke-width="1"
                ></line>
                <line
                  id="Line_8"
                  data-name="Line 8"
                  y1="12"
                  x2="11"
                  transform="translate(250 120)"
                  fill="none"
                  stroke-width="1"
                ></line>
                <line
                  id="Line_13"
                  data-name="Line 13"
                  x1="11"
                  y1="12"
                  transform="translate(250 132)"
                  fill="none"
                  stroke-width="1"
                ></line>
              </g>
            </svg>
          </span>
          <span class="label"> Back </span>
        </span>
      </a>
    </div>
    <div
      class="methods-c"
      :style="{
        transform: zoomTransform,
        'transform-origin': zoomTransformOrigin,
      }"
    >
      <svg
        viewBox="-20 0 875.8 745.3"
        style="
          transform: scale(0.1);
          width: 6750px;
          height: 5744px;
          transform-origin: 100% 100%;
          margin: -5169.6px 0 0 -6075px;
        "
      >
        <defs>
          <clipPath id="clip-path">
            <rect x="-21.5" y="-20.7" width="41.4" height="20.68" fill="none" />
          </clipPath>
          <clipPath id="clip-path-2">
            <rect x="-21.5" y="0" width="41.4" height="20.68" fill="none" />
          </clipPath>
        </defs>
        <path
          ref="path"
          class="animated"
          d="M22.2,149.1S35.4,266.7,79.8,320.9c42,37.6,55.7,72.8,180.6,83.2,120.2-5.1,155.8-24,215-94.2,59.2-75.8,214.9-207.6,317.4,66.6C817.1,601,669,650.7,546.4,621.7"
          fill="none"
          stroke="#676767"
          :stroke-dasharray="pathStroke"
          style="visibility: hidden"
        />
        <path
          ref="path2"
          class="animated"
          :d="pathLine2"
          fill="none"
          stroke="#676767"
          :stroke-dasharray="pathStroke2"
        />
        <circle
          :cx="pointPos.x"
          :cy="pointPos.y"
          r="10"
          fill="#E9993E"
          :transform-origin="pointPos.x + ' ' + pointPos.y"
          :transform="'scale(' + circleScale + ')'"
        />

        <methodology-point
          :key="'point' + pi"
          v-for="(point, pi) in points"
          :pos="point.p"
          :title="point.title"
          :sub="point.sub"
          :rotation="point.r"
          :progress="progForPoint(point)"
          :progress2="progForPoint2(point)"
          v-on:click.native="selectPoint(pi)"
          :zoom="selectedPoint === pi"
          :length="point.l"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    isMounted: false,
    pointProgress: -10,
    pointProgress2: -10,
    points: [
      { p: 0, r: -20, title: 'Script', sub: [] },
      {
        p: 11,
        r: -58,
        title: '2d Animation',
        sub: [
          { p: 60, title: 'Storyboard' },
          { p: 140, title: 'Animatic' },
        ],
      },
      { p: 22, r: -72, title: 'Asset Development', sub: [] },
      { p: 33, r: -90, title: 'Layout', sub: [] },
      { p: 44, r: -95, l: 100, title: 'Animation', sub: [] },
      { p: 55, r: -58, l: 80, title: 'VFX / CHF', sub: [] },
      {
        p: 66,
        r: -90,
        l: 80,
        title: 'LRC',
        sub: [
          { p: 60, title: 'Lighting' },
          { p: 140, title: 'Rendering' },
          { p: 220, title: 'Compositing' },
        ],
      },
      { p: 77, r: -90, title: 'Sound Design', sub: [] },
      { p: 88, r: -105, title: 'Final Editing', sub: [] },
      { p: 100, r: -75, title: 'Delivery', sub: [] },
    ],
    // points: [
    //   {p:   0, r: -20, title: "First key point", sub: [
    //     {p: 60, title: "First sub point"},
    //     {p: 140, title: "Second sub point"},
    //     {p: 220, title: "Third sub point"},
    //     {p: 300, title: "Fourth sub point"},
    //   ]},
    //   {p:  10, r: -58, title: "Second key point", sub: []},
    //   {p:  20, r: -72, title: "Third key point", sub: []},
    //   {p:  30, r: -90, title: "Fourth key point", sub: []},
    //   {p:  40, r: -95, l: 100, title: "Fifth key point", sub: []},
    //   {p:  50, r: -58, l:  80, title: "Sixth key point", sub: []},
    //   {p:  60, r: -90, l:  80, title: "Seventh key point", sub: []},
    //   {p:  70, r: -90, title: "Eighth key point", sub: []},
    //   {p:  80, r: -105, title: "Ninth key point", sub: []},
    //   {p:  90, r: -75, title: "Tenth key point", sub: []},
    //   {p: 100, r: -75, title: "Eleventh key point", sub: []},
    // ],
    selectedPoint: null,
    activeSelectedPoint: null,
    pathLine2Cache: null,
  }),
  watch: {
    selectedPoint() {
      if (this.selectedPoint !== null)
        this.activeSelectedPoint = this.selectedPoint;
      else
        setTimeout(() => {
          if (this.selectedPoint === null) this.activeSelectedPoint = null;
        }, 1000);
      if (this.selectedPoint != null) {
        $('.methods-text').addClass('hidden');
      } else {
        $('.methods-text').removeClass('hidden');
      }
    },
  },
  computed: {
    zoomTransform() {
      var level = 1;
      if (this.selectedPoint !== null) {
        level = 10;
      }
      return 'scale(' + level + ')';
    },
    zoomTransformOrigin() {
      var x = 50;
      var y = 50;
      if (this.activeSelectedPoint !== null) {
        var p = this.pointAtProgress(this.points[this.activeSelectedPoint].p);
        x = p.x / 8.758;
        y = p.y / 7.453;
      }
      //       x=Math.min(100, Math.max(0, (x-50)*1.2+50));
      //       y=Math.min(100, Math.max(0, (y-50)*1.2+50));
      x = (x - 50) * 1.1 + 50;
      y = (y - 50) * 1.1 + 50;
      return x + '% ' + y + '%';
    },
    pointPos() {
      if (!this.isMounted) return { x: -20, y: -20 };
      return this.pointAtProgress(
        Math.max(0, Math.min(100, this.pointProgress2))
      );
    },
    circleScale() {
      return Math.min(1, Math.max(0, (this.pointProgress2 + 10) / 10));
    },
    pathStroke() {
      if (!this.isMounted) return '0.1,100000';
      if (!this.$refs.path) return '0.1,100000';
      var totalLength = this.$refs.path.getTotalLength();
      if (!totalLength) return '0.1,100000';
      return (
        Math.round(
          (totalLength * Math.min(100, Math.max(0, this.pointProgress))) / 100
        ) +
        ',' +
        totalLength
      );
    },
    pathLine2() {
      if (this.pathLine2Cache) return this.pathLine2Cache;
      if (!this.isMounted) return 'M0,0';
      if (!this.$refs.path) return 'M0,0';
      var points = [];
      var totalLength = this.$refs.path.getTotalLength();
      if (!totalLength) return 'M0,0';
      for (var point of this.points) {
        var pos = this.$refs.path.getPointAtLength(
          (point.p / 100) * totalLength
        );
        if (!points.length) points.push('M' + pos.x + ',' + pos.y);
        else points.push('L' + pos.x + ',' + pos.y);
      }
      this.pathLine2Cache = points.join(' ');
      return this.pathLine2Cache;
    },
    pathStroke2() {
      if (!this.isMounted) return '0.1,100001';
      if (!this.$refs.path2) return '0.1,100002';
      var totalLength = this.$refs.path2.getTotalLength();
      //       if (!totalLength)
      //         return "0.1,100003";
      return (
        Math.round(
          (totalLength * Math.min(100, Math.max(0, this.pointProgress))) / 100
        ) +
        ',' +
        totalLength
      );
    },
  },
  methods: {
    selectPoint(index) {
      if (this.selectedPoint == index) this.selectedPoint = null;
      else this.selectedPoint = index;
    },
    pointAtProgress(progress) {
      var path =
        this.$refs.path2 && this.$refs.path2.getTotalLength()
          ? this.$refs.path2
          : this.$refs.path;
      var totalLength = path.getTotalLength();
      var result = path.getPointAtLength((totalLength * progress) / 100);
      return { x: result.x, y: result.y };
    },
    progForPoint(point) {
      var relProgress = this.pointProgress - point.p;
      return relProgress;
    },
    progForPoint2(point) {
      var relProgress = this.pointProgress2 - point.p;
      return relProgress;
    },
    startAnim() {
      if (this.activeSelectedPoint === null) {
        var add = 0.33;
        var addSpc = 10000;
        for (var point of this.points)
          addSpc = Math.min(addSpc, Math.abs(this.pointProgress - point.p));
        //       console.log(addSpc);
        if (addSpc < 5) {
          add = (addSpc * 0.3) / 5 + 0.03;
        }
        this.pointProgress += add;
        this.pointProgress2 += add;
      }
      if (this.pointProgress < 120) setTimeout(() => this.startAnim(), 16);
      else setTimeout(() => this.startAnim2(), 16);
    },
    startAnim2() {
      if (this.activeSelectedPoint === null) {
        var add = 0.33;
        var addSpc = 10000;
        for (var point of this.points)
          addSpc = Math.min(addSpc, Math.abs(this.pointProgress2 - point.p));
        //       console.log(addSpc);
        if (addSpc < 5) {
          add = (addSpc * 0.3) / 5 + 0.03;
        }
        this.pointProgress2 += add;
        if (this.pointProgress2 >= 120) this.pointProgress2 = -10;
      }
      setTimeout(() => this.startAnim2(), 16);
    },
  },
  mounted() {
    this.isMounted = true;
    window.methodologyEl = this;
    if (this.$el.getBoundingClientRect().y<window.innerHeight) {
      this.startAnim();
    }
    //     this.startAnim();
  },
};
</script>
